import type { Translation } from '../translations.types';

const translations: Translation = {
  logout: 'Sair',
  openMenu: 'Abrir Menu',
  closeMenu: 'Fechar Menu',
  author: 'Publicado por',
  'add-review': 'Mmm! Partilhe a sua experiência gastronómica!',
  'add-review-to-food': 'Conte-nos sobre a sua experiência com {{food}}',
  food: {
    title: 'Comida',
    gourmets: 'Fãs de {{food}}',
    bestPlaces: 'Melhores lugares para {{food}}',
    gourmetsSectionDescription:
      'Descubra quem conhece bem {{food}}! Os nossos gourmets são classificados pelo número de vezes que experimentaram e o que acharam.',
    bestPlacesSectionDescription:
      'À procura de {{food}} incrível? Estes lugares são avaliados por pessoas que sabem do que falam!',
    beTheFirstReviewer: {
      title: 'Seja o primeiro a avaliar {{foodName}}!',
      description: 'A sua experiência gastronómica é importante! Partilhe a sua avaliação e ajude outros apreciadores a descobrir este prato.',
      button: 'Escrever a primeira avaliação'
    }
  },
  drink: 'Bebida',
  place: 'Local',
  'where-did-you-eat': 'Onde comeu isto?',
  'what-did-you-eat': 'O que experimentou?',
  localeCurrency: 'Moeda local',
  category: 'Categoria',
  name: 'Nome',
  rating: 'A sua pontuação',
  welcome_modal: {
    title: 'Bem-vindo ao BiteCritic!',
    subtitle: 'Descubra o seu próximo prato favorito',
    description:
      'O BiteCritic é uma comunidade de amantes de comida que partilham as suas experiências e avaliam a comida que experimentaram.',
    features: {
      title: 'Com o BiteCritic, pode:',
      rate: 'Avaliar pratos com base no sabor, não apenas restaurantes',
      discover: 'Descobrir novos alimentos baseados em avaliações autênticas',
      connect: 'Conectar-se com outros entusiastas de comida',
      track: 'Acompanhar os alimentos que deseja experimentar',
    },
    not_now: 'Agora não',
    join_now: 'Junte-se agora',
  },
  review: {
    label: 'Sua Opinião',
    writingIn: 'Estou escrevendo esta avaliação em',
    success: 'Sua história está no ar!',
    error: 'Ops! Algo deu errado ao compartilhar sua história',
    foodReviewTitle:
      'Avaliação de {{foodName}} por {{username}} em {{placeName}}, {{city}}',
    drinkReviewTitle:
      'Avaliação de {{drinkName}} por {{username}} em {{placeName}}, {{city}}',
  },
  previous: 'Voltar',
  next: 'Seguinte',
  'submit-review': 'Partilhe a sua história',
  cancel: 'Cancelar',
  type: 'Que tipo',
  'add-food-review': 'O que comeu?',
  'select-food': 'Escolha o seu prato',
  cost: 'Quanto custou?',
  'rating-explanation': 'Avalie! (1 = meh, 10 = incrível!)',
  'write-your-review': 'Conte-nos tudo...',
  'visited-at': 'Quando foi?',
  reviews: {
    noReviews: 'Nenhuma avaliação encontrada',
    readFull: 'Leia a história completa',
    showTranslation: 'Mostrar tradução',
    showOriginal: 'Mostrar original',
    translatedFrom: 'Traduzido do {{language}}',
    filters: {
      title: 'Filtros',
      apply: 'Aplicar filtros',
      rating: 'Avaliação',
      cost: 'Custo',
      startDate: 'De',
      endDate: 'Até',
      location: 'Localização',
      radius: 'Raio de pesquisa (km)',
      sort: {
        label: 'Ordenar por',
        newest: 'Mais recentes primeiro',
        oldest: 'Mais antigos primeiro',
        mostLiked: 'Melhor avaliados',
        leastLiked: 'Pior avaliados',
        mostExpensive: 'Mais caros',
        cheapest: 'Mais baratos',
      },
      sortOrder: {
        asc: 'ascendente',
        desc: 'descendente',
      },
      sortBy: {
        createdAt: 'Data',
        likeCount: 'Gostos',
        cost: 'Preço',
      },
      active: {
        rating: 'Avaliação mínima: {{value}}',
        startDate: 'De: {{date}}',
        endDate: 'Até: {{date}}',
        cost: 'Custo mínimo: {{value}}',
        radius: 'Dentro de {{value}}km',
      },
    },
  },
  languages: {
    en: 'Inglês',
    nl: 'Holandês',
    tr: 'Turco',
    de: 'Alemão',
    fr: 'Francês',
    es: 'Espanhol',
    it: 'Italiano',
    pt: 'Português',
    select: 'Selecionar idioma',
  },
  validation: {
    'place-required': 'Ops! Escolha primeiro um local',
    'category-required': 'Escolha uma categoria!',
    'review-min-length':
      'Um pouco mais de detalhe seria ótimo (pelo menos 80 caracteres)',
    'rating-required': 'Não se esqueça de avaliar!',
    'cost-positive': 'O preço deve ser maior que zero',
    'visited-at-required': 'Quando foi?',
    'type-required': 'Comida ou bebida?',
    'food-required': 'O que comeu?',
    'drink-required': 'O que bebeu?',
    'country-required': 'De onde é?',
    required: 'Este campo é obrigatório',
  },
  auth: {
    welcomeBack: 'Olá! 👋',
    loginToContinue: 'Entre novamente',
    continueWithGoogle: 'Continuar com Google',
    continueWithApple: 'Continuar com Apple',
    logout: 'Até breve!',
    login: 'Entrar',
    signup: 'Junte-se à festa gastronómica!',
    signupToContinue: 'Junte-se à festa gastronómica!',
    joinCommunity: 'Junte-se à festa gastronómica!',
    required: 'Vamos começar!',
    actionRequiresAuth: 'Ops! É necessário um login rápido para isso',
    alreadyLoggedIn: 'Já tem sessão iniciada!',
    goToProfile: 'Ir para o Perfil',
    continueToFeed: 'Continuar para o Feed',
    alreadyHaveAccount: 'Já tem uma conta?',
    benefits: {
      title: 'Veja o que está a perder:',
      follow: 'Acompanhe as suas comidas favoritas',
      review: 'Partilhe as suas aventuras gastronómicas',
      save: 'Guarde locais para mais tarde',
      community: 'Conheça outros amantes de comida',
      personalized: 'Receba dicas de comida só para si',
    },
    cta: {
      login: 'Vamos lá!',
      cancel: 'Talvez mais tarde',
    },
    actions: {
      followFood: 'Login rápido para seguir este delicioso prato!',
      unfollowFood: 'Faça login para deixar de seguir',
    },
    joinNow: 'Junte-se agora!',
  },
  profile: {
    follow: 'Seguir',
    unfollow: 'Deixar de seguir',
    followers: 'Seguidores',
    following: 'A seguir',
    avatar: 'A sua foto',
    change_avatar: 'Nova foto',
    upload_avatar: 'Carregar foto',
    title: 'O seu perfil',
    view: 'Ver perfil',
    username: 'Nome de utilizador',
    email: 'Email',
    success: 'Parece bom!',
    error: 'Ops, algo correu mal',
    save: 'Guardar',
    firstName: 'Nome próprio',
    lastName: 'Apelido',
    birthDate: 'Data de nascimento',
    country: 'País',
    bio: 'Sobre si',
    bioPlaceholder: 'Conte-nos sobre as suas aventuras gastronómicas...',
    selectCountry: 'Selecione o seu país',
    deleteAccount: {
      button: 'Eliminar conta',
      title: 'Eliminar a sua conta',
      warning:
        'Aviso: Esta ação não pode ser desfeita. Todos os seus dados, avaliações e preferências serão permanentemente eliminados.',
      confirm: 'Eliminar a minha conta',
      error:
        'Falha ao eliminar a conta. Por favor, tente novamente mais tarde.',
    },
    noAccount: 'Não tem uma conta?',
  },
  errors: {
    invalidFileType:
      'Tipo de ficheiro inválido. Por favor, carregue apenas imagens JPG, PNG, WebP, HEIC ou HEIF.',
    fileTooLarge: 'O ficheiro é demasiado grande. O tamanho máximo é {{size}}.',
    tooManyFiles: 'Demasiados ficheiros. O máximo permitido é {{max}}.',
  },
  onboarding: {
    welcome: 'Bem-vindo ao BiteCritic!',
    setup_profile: 'Vamos configurar o seu perfil',
    username: 'Nome de utilizador',
    username_required: 'O nome de utilizador é obrigatório',
    username_min_length:
      'O nome de utilizador deve ter pelo menos 3 caracteres',
    username_pattern: 'Apenas letras, números e underscore são permitidos',
    username_taken: 'Este nome de utilizador já está em uso',
    username_available: 'Nome de utilizador disponível!',
    username_requirements:
      'O nome de utilizador deve ter pelo menos 3 caracteres e só pode conter letras, números e underscore',
    checking_username: 'A verificar disponibilidade do nome de utilizador...',
    first_name: 'Nome próprio',
    first_name_required: 'O nome próprio é obrigatório',
    first_name_min_length: 'O nome próprio deve ter pelo menos 2 caracteres',
    first_name_max_length: 'O nome próprio deve ter no máximo 20 caracteres',
    last_name: 'Apelido',
    last_name_required: 'O apelido é obrigatório',
    last_name_min_length: 'O apelido deve ter pelo menos 2 caracteres',
    last_name_max_length: 'O apelido deve ter no máximo 20 caracteres',
    birth_date: 'Data de nascimento',
    birth_date_required: 'A data de nascimento é obrigatória',
    country: 'País',
    complete_profile: 'Completar perfil',
    success: 'Perfil atualizado com sucesso!',
    error: 'Falha ao atualizar o perfil',
  },
  language: {
    select: 'Escolha o seu idioma',
    select_country: 'Onde está?',
    select_language: 'Que idioma?',
    current: 'Idioma atual',
  },
  categories: {
    title: 'Categorias de comida',
    meta: {
      title: 'Categorias de comida - Descubra delícias culinárias',
      description:
        'Explore as nossas diversas categorias de comida e descubra delícias culinárias de todo o mundo. Encontre avaliações, classificações e onde desfrutá-las.',
      categoryTitle: 'Categoria de comida',
      categoryDescription:
        'Explore {{category}} - Descubra {{count}} deliciosas comidas nesta categoria com avaliações e classificações de amantes de comida.',
      keywords:
        'categorias de comida, tipos de cozinha, exploração culinária, descoberta de comida',
      loading: 'A carregar categoria',
      defaultDescription:
        'Explore as nossas diversas categorias de comida e encontre a sua próxima aventura culinária.',
    },
  },
  common: {
    noMoreReviews: 'Não há mais avaliações',
    save: 'Guardar',
    error: {
      default: 'Ops!',
      fetchFailed: 'Falha ao obter dados',
      rateLimitExceeded:
        'Demasiados pedidos. Por favor, aguarde e tente novamente.',
    },
    search: 'Pesquisar',
    back: 'Voltar',
    cancel: 'Cancelar',
    loading: 'A carregar...',
    delete: 'Eliminar',
    create: 'Criar',
    open: 'Aberto',
    closed: 'Fechado',
    country: 'País',
    reviews: 'Avaliações',
    reviews_count: '{{count}} gourmets experimentaram isto',
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos',
    uploadImage: 'Carregar imagem',
    uploadMedia: 'Carregar mídia',
    deleteMedia: 'Eliminar mídia',
    uploadedMedia: 'Mídia carregada',
    sort: 'Ordenar por',
    loadMore: 'Carregar mais',
    backToHome: 'Voltar ao início',
    actions: {
      share: {
        label: 'Partilhar',
        copied: 'Link copiado para a área de transferência',
        copyFailed: 'Falha ao copiar link',
      },
    },
    exploreMore: 'Explorar mais',
    discoverExperiences: 'Descubra novas experiências culinárias',
    reachedEndOfContent: 'Chegou ao fim deste conteúdo',
    comingSoon: 'Brevemente',
    notNow: 'Agora não',
    close: 'Fechar',
    saveChanges: 'Guardar alterações',
    food: 'comida',
    previous: 'Anterior',
    next: 'Seguinte',
  },
  statuses: {
    active: 'Ativo',
    pending: 'Pendente',
    rejected: 'Rejeitado',
  },
  places: {
    radius: 'Distância',
    noPlacesFound: 'Nada aqui por enquanto',
    tryAdjustingFilters: 'Tente ajustar as suas opções de pesquisa',
    locationPermission: {
      title: 'Onde está?',
      description:
        'Partilhe a sua localização para encontrar lugares deliciosos nas proximidades',
      allow: 'Mostrar a minha localização',
    },
    whereDidYouEat: 'Onde comeu isto?',
    searchByLocation: 'Onde quer ir?',
    selectPlace: 'Digite o nome de um local',
    yourLocation: 'Está aqui',
    searchOrUseLocation:
      'Pesquise um local específico ou use a sua localização para descobrir lugares nas proximidades',
    locationStatus: {
      detecting: 'A detetar a sua localização...',
      denied: 'Acesso à localização negado',
      unavailable: 'Localização indisponível',
      found: 'Localização encontrada!',
    },
    sort: {
      title: 'Ordenar por',
      ratingDesc: 'Melhor classificados',
      ratingAsc: 'Pior classificados',
      distanceAsc: 'Mais próximos primeiro',
      distanceDesc: 'Mais distantes primeiro',
      nameAsc: 'Nome (A-Z)',
      nameDesc: 'Nome (Z-A)',
      reviewCountDesc: 'Mais avaliados',
      reviewCountAsc: 'Menos avaliados',
      newestFirst: 'Mais recentes primeiro',
      oldestFirst: 'Mais antigos primeiro'
    },
    period: {
      title: 'Período',
      ALL_TIME: 'Todo o tempo',
      LAST_WEEK: 'Última semana',
      LAST_MONTH: 'Último mês',
      LAST_YEAR: 'Último ano',
    },
    meta: {
      title: 'Descubra restaurantes perto de si',
      description: 'Encontre e explore os melhores restaurantes na sua área. Leia avaliações, veja fotos e descubra novas experiências gastronómicas.',
      titleWithPlace: 'Melhores lugares perto de {{place}}',
      descriptionWithPlace: 'Descubra os melhores restaurantes e locais gastronómicos perto de {{place}} num raio de {{radius}} km. Leia avaliações, consulte classificações e encontre o seu próximo lugar favorito para comer.'
    },
    navigation: {
      title: 'Locais',
    },
    detail: {
      error: 'Ups! Não conseguimos encontrar este local. Tente novamente?',
      sections: {
        popularFoods: {
          title: 'Os mais apreciados em {{place}}',
          description:
            'Estes pratos são os mais apreciados pela nossa comunidade de gourmets em {{place}}. Classificados por avaliações e número de opiniões.',
          titleWithCity: 'Os mais apreciados em {{place}} em {{city}}',
          descriptionWithCity:
            'Estes pratos são os mais apreciados pela nossa comunidade de gourmets em {{place}} em {{city}}. Classificados por avaliações e número de opiniões.',
        },
        gourmets: {
          title: 'Melhores gourmets em {{place}}',
          description:
            'Conheça os amantes de comida que melhor conhecem {{place}}. Estão classificados pelo número de avaliações e classificações.',
          titleWithCity: 'Melhores gourmets em {{place}} em {{city}}',
          descriptionWithCity:
            'Conheça os amantes de comida que melhor conhecem {{place}} em {{city}}. Estão classificados pelo número de avaliações e classificações.',
        },
        reviews: {
          title: 'Avaliações em {{place}}',
          titleWithCity: 'Avaliações em {{place}} em {{city}}',
        },
      },
    },
    emptyState: {
      title: 'Nenhum local encontrado',
      description: '{{username}} ainda não avaliou nenhum local.'
    },
    userMapTitle: 'Mapa gastronómico de {{username}}',
        reviewsDrawer: {
      title: 'Avaliações para {{placeName}}',
      noReviews: 'Ainda não há avaliações para este local.',
      viewMore: 'Ver todas as avaliações',
      addReview: 'Adicionar avaliação'
    },
    viewAllVisited: 'Todos os locais que {{username}} visitou e avaliou'
  },
  settings: {
    title: 'As suas definições',
  },
  home: 'Início',
  'review-not-found': 'Não foi possível encontrar esta avaliação',
  'go-back': 'Voltar',
  actions: {
    share: 'Partilhar com amigos',
  },
  users: {
    title: 'Entusiastas de Comida',
    searchPlaceholder: 'Pesquisar por nome...',
    noResults: 'Nenhum entusiasta de comida encontrado',
    seoTitle: 'Críticos de Comida e Avaliadores',
    seoDescription:
      'Descubra críticos de comida e avaliadores na sua área. Conecte-se com amantes da comida que compartilham suas paixões culinárias e descubra novas experiências gastronômicas.',
    seoKeywords:
      'críticos de comida, avaliadores de comida, especialistas culinários, amantes da comida, gourmets',
    navigation: {
      title: 'Foodies',
    },
    stats: {
      followers: 'Seguidores',
      following: 'A seguir',
      rating: 'Avaliação',
      reviews: 'Avaliações',
    },
    map: {
      viewMap: 'Ver Mapa Gastronómico',
      seoTitle: 'Mapa gastronómico de {{username}}',
      seoDescription: 'Explore os locais que {{username}} visitou e avaliou no seu mapa gastronómico.'
    },
    detail: {
      sections: {
        visitedPlaces: {
          title: 'Locais Recentes de {{username}}',
          description: 'Lugares onde {{username}} compartilhou experiências culinárias',
        },
        likedFoods: {
          title: 'Comidas Favoritas de {{username}}',
          description: 'Pratos que {{username}} experimentou e avaliou',
        },
      },
    },
  },
  foods: {
    title: 'Pratos',
    meta: {
      title: 'Descubra pratos perto de si',
      description:
        'Explore e descubra pratos deliciosos na sua área. Navegue por avaliações, classificações e fotos de vários pratos de restaurantes locais.',
    },
    searchPlaceholder: 'Pesquisar pratos...',
    noResults: 'Nenhum prato encontrado',
    sort: {
      nameAsc: 'Nome A-Z',
      nameDesc: 'Nome Z-A',
      ratingDesc: 'Melhor classificados',
      ratingAsc: 'Pior classificados',
      reviewCountDesc: 'Mais avaliações',
      reviewCountAsc: 'Menos avaliações',
    },
    period: {
      allTime: 'Todo o tempo',
      lastWeek: 'Última semana',
      lastMonth: 'Último mês',
      lastYear: 'Último ano',
    },
  },
  navigation: {
    home: 'Início',
    discover: 'Descobrir',
    community: 'Comunidade',
    support: 'Suporte',
    myProfile: 'Meu Perfil',
    myFeed: 'Meu Feed',
    gourmets: 'Gourmets',
    placesNearMe: 'Locais perto de mim',
    foodsNearMe: 'Pratos perto de mim',
    popularPlacesMonth: 'Locais mais bem avaliados do mês',
    mostReviewedPlacesMonth: 'Locais mais avaliados do mês',
    popularGourmetsMonth: 'Gourmets populares do mês',
    popularFoodsMonth: 'Pratos populares do mês',
    popular: 'Popular',
    contact: 'Contacto',
    privacy: 'Política de Privacidade',
    terms: 'Termos e Condições',
  },
  error: {
    pageNotFound: 'Página não encontrada',
    pageNotFoundDescription:
      'A página que procura pode ter sido removida, mudou de nome ou está temporariamente indisponível.',
    needHelp: 'Precisa de ajuda?',
    contactUs:
      'Contacte a nossa equipa de suporte e ajudá-lo-emos a encontrar o que procura.',
  },
  contact: {
    title: 'Contacte-nos',
    name: 'O seu nome',
    email: 'Endereço de email',
    message: 'Mensagem',
    send: 'Enviar mensagem',
    nameRequired: 'Por favor, introduza o seu nome',
    emailRequired: 'Por favor, introduza o seu email',
    emailInvalid: 'Por favor, introduza um email válido',
    messageRequired: 'Por favor, introduza a sua mensagem',
    pageTitle: 'Entre em contacto',
    pageDescription:
      'Tem perguntas ou precisa de assistência? Estamos aqui para ajudar! Preencha o formulário abaixo ou envie-nos um email diretamente.',
  },
  seo: {
    keywords: {
      food: 'comida',
      cuisine: 'cozinha',
      reviews: 'avaliações',
      rating: 'classificação',
      restaurants: 'restaurantes',
      dining: 'gastronomia',
    },
    food: {
      title: 'Avaliação de {{foodName}}',
      description:
        'Descubra os melhores lugares para comer {{foodName}}. Leia avaliações honestas e encontre onde saborear o mais delicioso {{foodName}} perto de si no BiteCritic.',
      defaultDescription:
        'Descubra {{foodName}} - avaliações, classificações e onde encontrar o melhor {{foodName}} perto de si.',
    },
    place: {
      defaultDescription:
        'Explore {{placeName}} - avaliações, classificações e pratos populares neste local.',
      cityDescription:
        'Explore {{placeName}} em {{cityName}} - avaliações, classificações e pratos populares neste local.',
    },
    review: {
      defaultDescription:
        'Leia a avaliação de {{username}} sobre {{foodName}} em {{placeName}} - classificações, fotos e experiência detalhada.',
      foodTitle: 'Avaliação de {{foodName}} em {{placeName}} - {{rating}}/10',
      placeTitle: 'Avaliação de {{placeName}} - {{rating}}/10',
      metaDescription:
        'Leia a avaliação detalhada de {{username}} sobre {{foodName}} em {{placeName}}. Avaliação: {{rating}}/10. Descubra o que torna este {{type}} especial.',
      authorTitle:
        'Avaliação de {{username}} sobre {{foodName}} em {{placeName}}',
      ratingScale: 'Escala de avaliação: 0-10',
      reviewedType: {
        food: 'Prato',
        restaurant: 'Restaurante',
        product: 'Produto',
      },
    },
    user: {
      defaultDescription:
        'Descubra o percurso gastronómico de {{username}} - avaliações, pratos favoritos e aventuras culinárias.',
    },
    category: {
      defaultDescription:
        'Explore os pratos de {{categoryName}} - descubra os melhores pratos, avaliações e onde encontrá-los perto de si.',
    },
    meta: {
      siteName: 'BiteCritic',
      defaultTitle:
        'BiteCritic - Descubra e partilhe experiências gastronómicas',
      defaultDescription:
        'Junte-se aos amantes de comida de todo o mundo para descobrir e partilhar experiências gastronómicas incríveis. Encontre avaliações autênticas, classificações e fotos de pratos perto de si.',
      defaultKeywords:
        'comida, restaurantes, avaliações, gastronomia, culinária, críticos gastronómicos',
    },
  },
  feed: {
    title: 'O seu percurso gastronómico pessoal',
    description:
      'Siga os seus pratos, locais e gourmets favoritos para criar o seu feed gastronómico perfeito. Obtenha recomendações personalizadas e nunca perca uma boa refeição.',
    discover: 'Começar a descobrir',
    personalizedTitle: 'O seu feed gastronómico',
    allReviewsTitle: 'Últimas histórias gastronómicas',
    personalizedDescription:
      'Veja as avaliações dos pratos, locais e gourmets que segue.',
    joinCommunityDescription:
      'Junte-se à nossa comunidade para um feed personalizado baseado nos seus interesses.',
    noRelatedReviews:
      'Ainda não temos avaliações que correspondam aos seus interesses. Vamos descobrir algumas histórias globais!',
    showGlobalFeed: 'Mostrar feed global',
    myFeed: 'O meu feed',
    globalFeed: 'Feed global',
    globalDescription:
      'Descubra as últimas histórias gastronómicas de todo o mundo.',
    noGlobalReviews:
      'Não há avaliações globais disponíveis no momento. Volte em breve!',
    meta: {
      title: 'Feed gastronómico - O seu percurso gastronómico personalizado',
      description:
        'Descubra as últimas avaliações e histórias gastronómicas dos seus pratos, locais e gourmets favoritos. Obtenha recomendações personalizadas baseadas nos seus gostos.',
      keywords:
        'feed gastronómico, avaliações de comida, recomendações personalizadas, histórias gastronómicas, comunidade gastronómica',
    },
    followFoods: {
      title: 'Seguir pratos',
      description:
        'Mantenha um registo dos seus pratos favoritos e descubra novas variações.',
    },
    followPlaces: {
      title: 'Seguir locais',
      description:
        'Mantenha-se atualizado sobre as últimas avaliações dos seus locais favoritos.',
    },
    followGourmets: {
      title: 'Seguir gourmets',
      description:
        'Conecte-se com amantes de comida que partilham os seus gostos e descubra as suas recomendações.',
    },
  },
  app: {
    actions: 'Ações da Aplicação',
  },
  download: {
    ios_app: 'Descarregar Aplicação iOS',
    android_app: 'Descarregar Aplicação Android',
  },
  notifications: {
    title: 'Notificações',
    pageTitle: 'Notificações',
    pageDescription: 'Gerencie suas notificações',
    markAllAsRead: 'Marcar tudo como lido'
  },
  endOfScroll: {
    placesNearMe: 'Locais Próximos',
    placesNearMeSubtitle: 'Encontre restaurantes e estabelecimentos próximos',
    globalFeed: 'Feed Global',
    globalFeedSubtitle: 'Veja o que os outros estão a gostar',
    findPeople: 'Encontrar Foodies',
    findPeopleSubtitle: 'Conecte-se com outros amantes de comida',
    foodsNearMe: 'Comidas Próximas',
    foodsNearMeSubtitle: 'Descubra pratos populares na sua área',
  },
  // Step explanations and icon titles for review modal
  'media': 'Mídia',
  'media.image': 'Imagem',
  'media.video': 'Vídeo',
  'location': 'Localização',
  // New review modal step explanations
  'review-modal-media-explanation': 'Tire uma foto ou escolha uma do seu álbum para mostrar o seu prato!',
  'review-modal-rating-explanation': 'Como estava o sabor? Dê sua avaliação honesta.',
  'review-modal-location-explanation': 'Onde você degustou este prato? Informe aos outros!',
  // Draft management
  'draft-cleared': 'Rascunho apagado com sucesso!',
  'draft-save-error': 'Ops! Não foi possível salvar seu rascunho',
  'clear-draft': 'Apagar rascunho',
  comments: {
    title: 'Comentários',
    subtitle: 'Participe da conversa',
    writeComment: 'Escreva um comentário...',
    submit: 'Publicar',
    delete: 'Excluir',
    noComments: 'Ainda não há comentários. Seja o primeiro a comentar!',
    loginToComment: 'Por favor, faça login para deixar um comentário',
    loadMore: 'Carregar mais',
    commentAdded: 'Comentário adicionado com sucesso',
    commentError: 'Falha ao adicionar comentário',
    commentDeleted: 'Comentário excluído',
    deleteError: 'Falha ao excluir comentário',
    post: 'Publicar',
    placeholder: 'Escreva um comentário...',
  },
  mentions: {
    noUsersFound: 'Nenhum usuário encontrado',
    searchingUsers: 'Procurando por usuários...',
  },
};

export default translations;
